import { useEffect } from "react";

function updateAppHeight() {
  // 인앱 WebView 전용. iOS(keyboard constraint)·Android(ime inset) 모두 native 가
  // WebView 프레임 자체를 키보드 높이만큼 resize 하므로 innerHeight 가 키보드 상태를
  // 이미 반영한다. visualViewport.height 는 iOS 26.0.1 등에서 키보드 dismiss 후
  // 갱신되지 않는 버그(innerHeight 812 정상인데 visualViewport 744 로 고착 → 하단 여백)가
  // 있어 innerHeight 를 신뢰한다. (실브라우저 키보드 오버레이 모델은 대상 아님)
  const h = window.innerHeight;
  document.documentElement.style.setProperty("--app-height", `${h}px`);
}

/** --app-height 를 가시 뷰포트 높이로 동기화 — 엔진 floor Safari 14.1 은 100dvh 미지원(15.4+)이라 필요. 키보드·회전은 window/visualViewport resize·orientationchange 로 따라간다(신호 선택 이유는 updateAppHeight 주석). Router 최상단에서 1회 호출. */
export function useAppHeight(): void {
  useEffect(() => {
    updateAppHeight();

    // native 프레임 resize 는 window resize 로 통지된다(키보드 dismiss 후 프레임 복귀 포함).
    // visualViewport.resize 는 일부 iOS 버전에서 dismiss 후 미발화 → window resize 로 보강.
    window.addEventListener("resize", updateAppHeight);
    window.visualViewport?.addEventListener("resize", updateAppHeight);
    window.addEventListener("orientationchange", updateAppHeight);

    return () => {
      window.removeEventListener("resize", updateAppHeight);
      window.visualViewport?.removeEventListener("resize", updateAppHeight);
      window.removeEventListener("orientationchange", updateAppHeight);
    };
  }, []);
}
